export const configureRowStatement = (listData, nameRow)=>{  //property) => {

    listData[nameRow] = listData[nameRow].map(obj => obj.name);
    let suffix = nameRow +"RegisterInput"
    let input = listData[suffix]
    if (input != null && input.trim().length != 0) {
        listData[nameRow].push(input)
    }
    let data= [];
    for (let i = 0; i < listData[nameRow].length; i++) {
        let row = listData[nameRow][i]
        
        if (row.trim().length != 0) {
            data.push(row);
        }
    }
    delete listData[suffix];

    return listData

}